export default "__VITE_ASSET__D7w9pYJI__"